var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field datepicker"},[_c('flat-pickr',{attrs:{"config":_vm.options,"placeholder":_vm.placeholder},model:{value:(_vm.time_formatted),callback:function ($$v) {_vm.time_formatted=$$v},expression:"time_formatted"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prefix date"},[_c('span',{staticClass:"icon-calendar"})])
}]

export { render, staticRenderFns }